import { Group } from '../security/model/group';
import { DatePipe } from '@angular/common';

export class User {
    id: string;
    name: string;
    displayName: string;
    groups: Array<Group>;
    options: any = { };
    constructor(name?: string, groups?: Array<Group>) {
        if (name) {
            this.name = name;
        }
        if (groups) {
            this.groups = groups;
        }
    }
}


export class UserDateFormat {
    format: string;
    example: string; 
    constructor(format: string, private datePipe: DatePipe) {
        this.format = format;
        this.example = this.datePipe.transform(new Date, format);
    }
}